import { claimRepository } from '~/api/repository/claim';

export const CLAIM_QUERY_KEY = {
  all: ['claim'] as const,

  // 교환/반품 목록 조회 (무한 스크롤)
  histories: () => ({
    queryKey: ['/api/market-place/v1/claim'] as const,
    queryFn: ({ pageParam }: { pageParam?: number } = {}) =>
      claimRepository.getClaims({ lastOfferId: pageParam }),
    infinite: true,
  }),

  // 취소 가능 상품 조회
  cancellable: (orderId: number) => ({
    queryKey: [
      '/api/market-place/v2/orders/{orderId}/cancellable-product-orders',
      orderId,
    ] as const,
    queryFn: () => claimRepository.getCancellableProductOrders(orderId),
  }),

  // 취소 완료 상품 상세 조회
  canceledDetail: (productOrderId: number) => ({
    queryKey: [
      '/api/market-place/v1/claim/cancellation/{productOrderId}/detail',
      productOrderId,
    ] as const,
    queryFn: () => claimRepository.getCanceledProductDetail(productOrderId),
  }),

  // 교환/반품 가능 상품 조회
  claimable: (vendorOrderId: number) => ({
    queryKey: [
      '/api/market-place/v1/orders/{vendorOrderId}/claimable-product-orders',
      vendorOrderId,
    ] as const,
    queryFn: () => claimRepository.getClaimableProductOrders(vendorOrderId),
  }),

  // 교환/반품 사유 목록 조회
  reasons: () => ({
    queryKey: ['/api/market-place/v1/claim/reason'] as const,
    queryFn: () => claimRepository.getClaimReasons(),
  }),

  // 교환/반품 상세 조회
  detail: (claimId: number) => ({
    queryKey: ['/api/market-place/v1/claim/{claimId}/detail', claimId] as const,
    queryFn: () => claimRepository.getClaimDetail(claimId),
  }),
};
